import React from "react";
import { Container } from "react-grid-system";
import WarningIcon from "../../asset/warningIcon.svg";
import style from "./Style.module.css";

const banks = [
  "ธ. ไทยพาณิชย์",
  "ธ. กรุงเทพ จำกัด (มหาชน)",
  "ธ. กสิกรไทย จำกัด (มหาชน)",
  "ธ. กรุงไทย จำกัด (มหาชน)",
  "ธ. ทหารไทย จำกัด (มหาชน)",
  "ธ. ออมสิน",
  "ธ. กรุงศรีอยุธยา จำกัด (มหาชน)",
  "ธ. อาคารสงเคราะห์",
  "ธ. เพื่อการเกษตรและสหกรณ์การเกษตร",
  "ธ. ซิตี้แบงก์ เอ็น.เอ.",
  "ธ. อิสลามแห่งประเทศไทย",
  "ธ. ซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น",
  "ธ. สแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)",
  "ธ. ซีไอเอ็มบี ไทย จำกัด (มหาชน)",
  "ธ. ยูโอบี จำกัด (มหาชน)",
  "ธ. มิซูโฮ จำกัด สาขากรุงเทพฯ",
  "ธ. ธนชาต จำกัด (มหาชน)",
  "ธ. ทิสโก้ จำกัด (มหาชน)",
  "ธ. เกียรตินาคิน จำกัด (มหาชน)",
  "ธ. ไอซีบีซี (ไทย) จำกัด (มหาชน)",
  "ธ. ไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)",
  "ธ. แลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)",
];
const regexThaiName = /^[ก-๙a-zA-Z]{2,} [ก-๙a-zA-Z]{2,}$/;
class Nav extends React.Component {
  constructor(props) {
    super(props);
    var check = [
      "realName",
      "codeName",
      "peopleID",
      "bankInfo",
      "addSmall",
      "addSmallDistrict",
      "addDistrict",
      "addProvince",
      "addPostal",
      "phone",
      "email",
    ];
    for (var i = 0; i < check.length; i++)
      if (!props.info[check[i]]) props.info[check[i]] = "";
    this.state = Object.assign(props.info, {
      disabledName: this.checkIncludeLastName(props.info.realName),
    });
  }

  stripTitle(text) {
    return text.trim().replace(/^(นาย|นาง|นางสาว)\s+/, "");
  }

  checkIncludeLastName(text) {
    const withoutPrefixName = this.stripTitle(this.normalizeSpace(text));
    return regexThaiName.test(withoutPrefixName);
  }

  normalizeSpace = (text) => {
    return text.trim().replace(/\s+/g, " ");
  };

  render() {
    return (
      <Container>
        <div className={style.warningInfo}>
          <img src={WarningIcon} alt="waringIcon" />
          <span>
            ไม่สามารถแก้ไขข้อมูลผู้ขายชีทได้ในขณะนี้
            หากต้องการแก้ไขข้อมูลกรุณาติดต่อผ่านอีเมล contact@moresheet.co
          </span>
        </div>
        <div className={style.dashPanel}>
          <div className={style.header}>แก้ไขข้อมูลผู้ขายชีท</div>
          <div className={style.label}>นามปากกา(ภาษาไทยหรืออังกฤษเท่านั้น)</div>
          <input
            className={style.textForm}
            type="text"
            value={this.state.codeName}
            disabled
            onChange={(event) => {
              this.setState({ codeName: event.currentTarget.value });
            }}
          />
          <div className={style.label}>ชื่อ-นามสกุล (ภาษาไทยเท่านั้น)</div>
          <input
            className={style.textForm}
            type="text"
            placeholder=""
            value={this.state.realName}
            disabled={this.state.disabledName}
            onChange={(event) => {
              this.setState({ realName: event.currentTarget.value });
            }}
          />
          <div className={style.label}>เบอร์โทรติดต่อ</div>
          <input
            className={style.textForm}
            type="text"
            placeholder=""
            value={this.state.phone}
            disabled
            onChange={(event) => {
              this.setState({ phone: event.currentTarget.value.trim() });
            }}
          />
          <div className={style.label}>อีเมล์ที่ติดต่อได้</div>
          <input
            className={style.textForm}
            type="text"
            placeholder=""
            value={this.state.email}
            onChange={(event) => {
              this.setState({ email: event.currentTarget.value.trim() });
            }}
          />
          <div className={style.label}>เลขบัตรประชาชน 13 หลัก</div>
          <input
            className={style.textForm}
            type="text"
            placeholder=""
            value={this.state.peopleID}
            disabled
            onChange={(event) => {
              this.setState({ peopleID: event.currentTarget.value.trim() });
            }}
          />
          <div className={style.label}>ธนาคารที่ใช้รับรายได้</div>
          <select
            className={style.textForm}
            value={this.state.bankName}
            disabled
            onChange={(event) => {
              this.setState({ bankName: event.currentTarget.value });
            }}
          >
            {this.genBankOptions()}
          </select>
          <div className={style.label}>เลขบัญชีธนาคาร (ตัวเลขเท่านั้น)</div>
          <input
            className={style.textForm}
            type="number"
            placeholder="Ex. 1234567890123"
            value={this.state.bankNumber}
            disabled
            onChange={(event) => {
              this.setState({ bankNumber: event.currentTarget.value.trim() });
            }}
          />
          <div className={style.label}>ที่อยู่ตามบัตรประชาชน</div>
          <hr />
          <div className={style.label}>บ้านเลขที่ ถนน ตรอก/ซอย หมู่</div>
          <input
            className={style.textForm}
            type="text"
            placeholder=""
            value={this.state.addSmall}
            disabled
            onChange={(event) => {
              this.setState({ addSmall: event.currentTarget.value });
            }}
          />
          <div className={style.label}>ตำบล/แขวง</div>
          <input
            className={style.textForm}
            type="text"
            placeholder=""
            value={this.state.addSmallDistrict}
            disabled
            onChange={(event) => {
              this.setState({ addSmallDistrict: event.currentTarget.value });
            }}
          />
          <div className={style.label}>อำเภอ/เขต</div>
          <input
            className={style.textForm}
            type="text"
            placeholder=""
            value={this.state.addDistrict}
            disabled
            onChange={(event) => {
              this.setState({ addDistrict: event.currentTarget.value });
            }}
          />
          <div className={style.label}>จังหวัด</div>
          <input
            className={style.textForm}
            type="text"
            placeholder=""
            value={this.state.addProvince}
            disabled
            onChange={(event) => {
              this.setState({ addProvince: event.currentTarget.value });
            }}
          />
          <div className={style.label}>เลขไปรษณีย์</div>
          <input
            className={style.textForm}
            type="text"
            placeholder=""
            value={this.state.addPostal}
            disabled
            onChange={(event) => {
              this.setState({ addPostal: event.currentTarget.value });
            }}
          />
          <div
            onClick={() => {
              this.saveData();
            }}
            className={style.registerButton}
          >
            แก้ไข
          </div>
        </div>
      </Container>
    );
  }

  saveData = () => {
    const phone = this.state.phone;
    const peopleID = this.state.peopleID;
    const bankNumber = this.state.bankNumber;
    this.setState({ realName: this.normalizeSpace(this.state.realName) });
    let error = "";

    const validateEmpty = (value, fieldName) => {
      if (value.trim().length === 0) {
        return `โปรดกรอกข้อมูลช่อง ${fieldName}\n`;
      }
      return "";
    };

    // Optional check for phone
    if (phone.length > 0 && !/^(?:\d{10}|\+66\d{9})$/.test(phone)) {
      error +=
        "หมายเลขโทรศัพท์ไม่ถูกต้อง (รับเฉพาะตัวเลข 10 หลัก หรือ +66..........)\n";
    }

    // Optional check for peopleId
    if (peopleID.length > 0 && !/^\d{13}$/.test(peopleID)) {
      error += "เลขบัตรประชาชน 13 หลักไม่ถูกต้อง (รับเฉพาะตัวเลข 13 หลัก)\n";
    }

    // Optional check for bankNumber
    if (!/^(?:\d{10}|\d{11}|\d{12}|\d{13}|\d{14}|\d{15})$/.test(bankNumber)) {
      error += "เลขบัญชีธนาคารไม่ถูกต้อง (รับเฉพาะตัวเลข 10-15 หลัก)\n";
    }

    error += validateEmpty(this.state.codeName, "นามปากกา");
    error += validateEmpty(this.state.realName, "ชื่อจริง");
    error += validateEmpty(this.state.peopleID, "เลขบัตรประชาชน");
    error += validateEmpty(this.state.bankNumber, "เลขบัญชีธนาคาร");
    error += validateEmpty(this.state.addSmall, "ที่อยู่/บ้านเลขที่");
    error += validateEmpty(this.state.addSmallDistrict, "ตำบล/แขวง");
    error += validateEmpty(this.state.addDistrict, "อำเภอ/เขต");
    error += validateEmpty(this.state.addProvince, "จังหวัด");
    error += validateEmpty(this.state.addPostal, "เลขไปรษณีย์");
    error += validateEmpty(this.state.phone, "เบอร์โทรศัพท์");
    error += validateEmpty(this.state.email, "อีเมล์");

    this.setState({
      disabledName: this.checkIncludeLastName(this.state.realName),
    });
    if (error.length > 0) {
      alert(error);
    } else {
      this.props.save(this.state);
    }
  };

  genBankOptions = () => {
    return banks.map((b) => {
      return (
        <option label={b} key={b} value={b}>
          {b}
        </option>
      );
    });
  };
}

export default Nav;
